'use client';
import CallAndWhatsApp from '@/app/_components/ui/icons/CallAndWhatsApp.svg';
import React from 'react';
import Link from 'next/link';
import PriceUnit from '../share/PriceUnit';
import Image from 'next/image';
import Cart from '@/app/_components/ui/icons/Cart.svg';
import AddToInvoiceButton from '../singleProduct/AddToInvoiceButton';
import { useState, useEffect } from 'react';
import useCart from '@/app/_hooks/useCart';
import LoadingIcon from '../share/LoadingIcon';
import { useChatContext } from '@/app/_providers/ChatContext';

export default function ArchiveRowProduct({
  product,
  index,
  selected,
  toggleSelectProduct,
}) {
  const { cart, addToCart } = useCart();
  const [isProductInCart, setIsProductInCart] = useState(false);
  const [isAddingToCart, setIsAddingToCart] = useState(false);
  const [iconColor, setIconColor] = useState('#2A75BB');
  const handleHover = () => {
    setIconColor('#fff');
  };
  const { isOpen, setIsOpen } = useChatContext();

  const handleUnhover = () => {
    setIconColor('#2A75BB');
  };
  useEffect(() => {
    if (cart && cart.items && product?.prices[0]) {
      setIsProductInCart(
        cart.items.some((item) => item.price_id === product?.prices[0]?.id)
      );
    }
  }, [cart, cart?.items]);

  const addToCartHandler = async () => {
    const cartItem = {
      number: 1,
      price_id: product?.prices[0]?.id,
      variation: {
        product: {
          media: {
            thumb: product.media?.thumb,
          },
          slug: product.slug,
          title: product.title,
        },
        regular: product?.prices[0]?.regular,
        sale: product?.prices[0]?.sale,
      },
    };
    try {
      setIsAddingToCart(true);
      await addToCart({ items: [cartItem] });
    } finally {
      setIsAddingToCart(false);
    }
  };

  return (
    <>
      <tr
        className={`${
          index % 2 === 1 ? 'bg-light-gray-50' : ''
        } border border-light-gray-300 leading-12 text-sm rounded-md border-b-0 sm:border-b`}
      >
        {/* Mobile Layout (Two Rows) */}
        <td colSpan="7" className=" sm:hidden p-2">
          {/* First Row (Title + Buttons) */}

          <div className="flex justify-between items-center">
            <div className="flex items-center">
              <input
                type="checkbox"
                className="border border-light-gray-300 rounded-sm ml-3 w-4 h-4"
                checked={selected}
                onChange={() => toggleSelectProduct(product.id)}
              />
              <Link
                className="text-xs leading-6 "
                href={`/product/${product.slug}`}
              >
                {product.title}
              </Link>
            </div>

            <div className="flex">
              {product.prices.length > 0 && !product.offline ? (
                isProductInCart ? (
                  <Link
                    href="/checkout/cart"
                    target="_blank"
                    className="border border-color-primary bg-color-primary rounded-md p-1"
                  >
                    <Cart stroke={'#fff'} />
                  </Link>
                ) : (
                  <button
                    className="border border-color-primary hover:bg-color-primary rounded-md p-1 bg-primary-25"
                    onMouseEnter={handleHover}
                    onMouseLeave={handleUnhover}
                    onClick={addToCartHandler}
                  >
                    {isAddingToCart ? (
                      <LoadingIcon />
                    ) : (
                      <Cart stroke={iconColor} />
                    )}
                  </button>
                )
              ) : (
                <button
                  className="border border-color-primary hover:bg-color-primary rounded-md p-1.5 bg-primary-25"
                  onMouseEnter={handleHover}
                  onMouseLeave={handleUnhover}
                  onClick={() => setIsOpen(true)}
                >
                  <CallAndWhatsApp fill={iconColor} />
                </button>
              )}
              <div className="flex items-center pr-2">
                <AddToInvoiceButton
                  currentVariationId={product?.prices[0]?.id}
                  productId={product.id}
                  showInList={true}
                />
              </div>
            </div>
          </div>

          {/* Second Row (Other Info) */}
          <div className="flex items-center h-[30px] text-xs">
            <div className="flex items-center mx-auto">
              <Image
                src={product.brand[0]?.thumb?.full_path}
                width={32}
                height={32}
                alt={product.brand[0]?.thumb?.alt}
              />
            </div>
            <div className="mx-auto">
              {product.prices.length > 0 ? (
                <div className="font-semibold flex items-center">
                  <PriceUnit price={product.prices[0].sale} />
                </div>
              ) : (
                <>تماس بگیرید</>
              )}
            </div>
            <div className="mx-auto">
              {product?.prices?.length > 0 && product?.prices[0]?.stock > 0 ? (
                <div>موجود</div>
              ) : (
                <div className="text-red-300">ناموجود</div>
              )}
            </div>
          </div>
        </td>

        {/* Desktop Layout (Single Row) */}
        <td className="hidden sm:table-cell text-right pr-4 no-print">
          <input
            type="checkbox"
            className="border border-light-gray-300 rounded-sm ml-3 w-4 h-4"
            checked={selected}
            onChange={() => toggleSelectProduct(product.id)}
          />
        </td>
        <td className="hidden sm:table-cell pl-2">
          <Image
            src={product.brand[0]?.thumb?.full_path}
            width={32}
            height={32}
            alt={product.brand[0]?.thumb?.alt}
          />
        </td>
        <td className="hidden sm:table-cell">
          <Link className="text-xs" href={`/product/${product.slug}`}>
            {product.title}
          </Link>
        </td>
        <td className="hidden sm:table-cell">
          {product.prices.length > 0 ? (
            <div className="flex items-center font-semibold">
              <PriceUnit price={product.prices[0].sale} />
            </div>
          ) : (
            <>تماس بگیرید</>
          )}
        </td>
        <td className="hidden sm:table-cell text-xs">
          {product?.prices?.length > 0 && product?.prices[0]?.stock > 0 ? (
            <div>موجود</div>
          ) : (
            <div className="text-red-300">ناموجود</div>
          )}
        </td>
        <td className="hidden sm:table-cell pl-6 text-left no-print">
          {product.prices.length > 0 && product.offline == false ? (
            <div className="flex items-center">
              {isProductInCart ? (
                <Link
                  href="/checkout/cart"
                  target="_blank"
                  className="border border-color-primary bg-color-primary rounded-md p-1.5 cursor-pointer"
                >
                  <Cart stroke={'#fff'} />
                </Link>
              ) : (
                <button
                  className="border border-color-primary hover:bg-color-primary rounded-md p-1.5 bg-primary-25 cursor-pointer"
                  onMouseEnter={handleHover}
                  onMouseLeave={handleUnhover}
                  onClick={addToCartHandler}
                >
                  {isAddingToCart ? (
                    <LoadingIcon />
                  ) : (
                    <Cart stroke={iconColor} />
                  )}
                </button>
              )}
            </div>
          ) : (
            <div className="flex items-center">
              <button
                className="inline-block border border-color-primary hover:bg-color-primary rounded-md p-1.5 bg-primary-25 cursor-pointer"
                onMouseEnter={handleHover}
                onMouseLeave={handleUnhover}
                onClick={() => setIsOpen(true)}
              >
                <CallAndWhatsApp fill={iconColor} />
              </button>
            </div>
          )}
        </td>
        <td className="hidden sm:table-cell no-print">
          {product?.prices?.length > 0 ? (
            <div className="flex items-center leading-3">
              <AddToInvoiceButton
                currentVariationId={product?.prices[0]?.id}
                productId={product.id}
                showInList={true}
              />
            </div>
          ) : (
            <div className="">...</div>
          )}
        </td>
      </tr>
    </>
  );
}
